interface IProps {
  size: number;
  stroke: string;
}

export const HandClickIcon = ({ size, stroke }: IProps) => {
  return (
    <svg id="handclickicon__assets-icons-v2__svg__l8"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-hand-click">
      
      <path id="handclickicon__assets-icons-v2__path__l20" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="handclickicon__assets-icons-v2__path__l21" d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
      <path id="handclickicon__assets-icons-v2__path__l22" d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5" />
      <path id="handclickicon__assets-icons-v2__path__l23" d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
      <path id="handclickicon__assets-icons-v2__path__l24" d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
      <path id="handclickicon__assets-icons-v2__path__l25" d="M5 3l-1 -1" />
      <path id="handclickicon__assets-icons-v2__path__l26" d="M4 7h-1" />
      <path id="handclickicon__assets-icons-v2__path__l27" d="M14 3l1 -1" />
      <path id="handclickicon__assets-icons-v2__path__l28" d="M15 6h1" />
    </svg>);

};